module.exports = __webpack_public_path__ + "img/apple.6ca7b115.svg";